// removed by extract-text-webpack-plugin
module.exports = {"headerTitle":"_1o5a0","header":"_1JzqO","search":"_1_DXP","count":"_34bYI","unsaved":"_3ddaP","saveSuccess":"TfH_M _3ddaP","sortLink":"_1M0jS","selectHeader":"_2UUZs _1JzqO","headerTitleLeft":"_24VMI","headerButtons":"_3Lqp_","headerButtonsLeft":"omjfV _3Lqp_","headerButtonsRight":"_3CRWq _3Lqp_","slider":"_1dkw8"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Album.css
// module id = 851
// module chunks = 0